module.exports = __webpack_public_path__ + "uarm-images/tinymce-icons_big.png";